(function() {
  window.uploadService = {
    // Single file upload with progress tracking
    uploadFile(data, onProgress = null) {
      return axios.post('/api/upload/file', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress && typeof onProgress === 'function') {
            onProgress(progressEvent);
          }
        }
      });
    },
    
    // Alias method for backward compatibility
    uploadFileWithProgress(data, onProgress = null) {
      return this.uploadFile(data, onProgress);
    },
    
    // Multiple files upload with progress tracking
    uploadMultipleFile(data, onProgress = null) {
      return axios.post('/api/upload/multiplefile', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress && typeof onProgress === 'function') {
            onProgress(progressEvent);
          }
        }
      });
    },
    
    // Delete single file
    deleteFile(folder, id, filename) {
      const data = { 
        folder, 
        id, 
        action: 'single' 
      };
      
      if (filename) {
        data.filename = filename;
      }
      
      return axios.delete('/api/upload/file', {
        data: data,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    
    // Delete all files in a folder/id
    deleteAllFiles(folder, id) {
      return axios.delete('/api/upload/file', {
        data: {
          folder,
          id,
          action: 'all'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    
    // Get files from folder
    getFiles(folder, id = null, type = 'all') {
      return axios.get('/api/upload/files', {
        params: { folder, id, type }
      });
    },
    
    // Get file statistics
    getFileStats(folder, id = null) {
      return this.getFiles(folder, id).then(response => {
        return response.data.stats;
      });
    },
    
    // Utility function to format file size
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    
    // Check if file type is supported
    isFileTypeSupported(filename, type = 'all') {
      const extension = filename.split('.').pop().toLowerCase();
      
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
      const videoTypes = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', '3gp', 'm4v'];
      const documentTypes = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
      
      switch (type) {
        case 'image':
          return imageTypes.includes(extension);
        case 'video':
          return videoTypes.includes(extension);
        case 'document':
          return documentTypes.includes(extension);
        case 'all':
        default:
          return [...imageTypes, ...videoTypes, ...documentTypes].includes(extension);
      }
    }
  };
})();